import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRecommend = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 0H3V3H0V5H3V8H5V5H8V3H5V0ZM12 3H20V5H12V3ZM12 13H20V15H12V13ZM12 17H20V19H12V17ZM6.29 12.29L4 14.59L1.71 12.29L0.29 13.71L2.59 16L0.29 18.29L1.71 19.71L4 17.41L6.29 19.71L7.71 18.29L5.41 16L7.71 13.71L6.29 12.29Z",
		fill: "currentColor"
	})
});
export default SvgRecommend;
